import React from "react";
import LoginForm from "../components/register/LoginForm";

function Login() {
	return <LoginForm />;
}

export default Login;
